const training = {
  // HeroSection
  'training.hero.homeLink': 'ホーム',
  'training.hero.aboutLink': 'アカデミーについて',
  'training.hero.currentPage': '実践トレーニング',
  'training.hero.title': '実践トレーニング',
  'training.hero.titleEn': 'PRACTICAL TRAINING',
  'training.hero.lead': '当アカデミーの学びの中心は、現場を想定した実技とロールプレイングです。講義で得た知識をすぐに体で覚え、本物の環境で即戦力を養います。実践を重視する日本の執事学校として、執事養成の核となる実技をここで体系的に磨きます。',
  'training.hero.imgAlt': 'テーブルセッティングを実技演習する受講生と指導する講師の様子',

  // BasicTraining
  'training.basic.label': 'BASIC TRAINING',
  'training.basic.title': '基礎トレーニング',
  'training.basic.titleEn': 'Basic Training',
  'training.basic.description': 'まずは理論で土台を作り、すぐに実技へ移ります。たとえばテーブルセッティングを学んだその日に、実際にフォーマルディナーを設定してみる——学びを体で覚える設計です。講義と実技の間を最短にすることで、知識が頭で終わらず身体に染み込むよう工夫しています。日本の執事学校ならではの実技中心の循環が、執事養成に必要な身体知を着実に育てます。',
  'training.basic.imgAlt': 'フォーマルディナーのテーブルセッティングを基礎から実習する受講生の様子',
  'training.basic.0.title': '講義と実技の直結',
  'training.basic.0.description': '座学の直後に実技演習を行うことで、知識が定着しやすく、疑問点をその場で解消できます。',
  'training.basic.1.title': '少人数制の徹底',
  'training.basic.1.description': '1クラス最大6名の完全少人数制。講師の目が全員に行き届き、一人ひとりの進度に合わせた指導が可能です。',
  'training.basic.2.title': '反復練習の重視',
  'training.basic.2.description': '基本の所作は何度でも繰り返します。正しい姿勢・歩き方・手の動きが自然にできるまで、根気よく指導します。',

  // BasicTraining hardcoded texts
  'training.basic.imgCaption': 'フォーマルディナーのセッティングを実習する受講生',
  'training.basic.sectionTitle': 'どんな実技訓練をするの？',
  'training.basic.sectionTitleEn': 'Theory Meets Practice',

  // RolePlaying
  'training.roleplay.label': 'ROLE-PLAYING',
  'training.roleplay.title': 'ロールプレイング実習',
  'training.roleplay.titleEn': 'Role-Playing Practice',
  'training.roleplay.description': '現場では、想定外のことが起こります。だからこそ、日常の家事サービスから晩餐会の運営、緊急時の対応まで、幅広い場面を想定して繰り返し練習します。実際の環境に近い設定で、臨機応変な対応力を養います。',
  'training.roleplay.scenario.label': 'レベル',
  'training.roleplay.0.title': '日常サービス',
  'training.roleplay.0.titleEn': 'Daily Service',
  'training.roleplay.0.level': '初級',
  'training.roleplay.0.description': '毎日の家事管理や来客応対を想定したシナリオ。ティーサービス、簡単なテーブルセッティング、基本的な所作の反復練習から始めます。',
  'training.roleplay.1.title': 'フォーマル晩餐会',
  'training.roleplay.1.titleEn': 'Formal Dinner',
  'training.roleplay.1.level': '中級',
  'training.roleplay.1.description': '複数名のゲストをもてなすフルコースディナーの運営。テーブルコーディネートからワインサービス、ゲストごとの対応までを総合的に実践します。',
  'training.roleplay.2.title': '緊急時対応',
  'training.roleplay.2.titleEn': 'Crisis Management',
  'training.roleplay.2.level': '上級',
  'training.roleplay.2.description': '予期せぬトラブルや緊急事態を想定した高度なシナリオ。冷静な判断力と、周囲を落ち着かせる所作を訓練します。マスターコースで扱います。',
  'training.roleplay.feature.0.label': '実際の環境に近い設定',
  'training.roleplay.feature.0.text': '邸宅や高級ホテルを模したスタジオで、現実に即した場面を忠実に再現します。',
  'training.roleplay.feature.1.label': '段階的に難易度を上げる',
  'training.roleplay.feature.1.text': '初級の基本所作から、上級の複合的な危機対応まで、着実にステップアップします。',
  'training.roleplay.feature.2.label': '即時フィードバック',
  'training.roleplay.feature.2.text': '実習の直後に講師が具体的な講評を行い、改善点をその場で明確にします。',

  // RolePlaying additional
  'training.roleplay.sectionTitleEn': 'Real Scenarios, Real Growth',
  'training.roleplay.level.0': '初級',
  'training.roleplay.level.1': '中級',
  'training.roleplay.level.2': '上級',

  // FeedbackSystem
  'training.feedback.label': 'FEEDBACK SYSTEM',
  'training.feedback.title': 'フィードバックの仕組み',
  'training.feedback.titleEn': 'Feedback System',
  'training.feedback.description': '実習の後には必ず講評の時間を設けています。講師が各受講生の所作・判断・コミュニケーションを細かく観察し、良かった点と改善点を具体的にフィードバック。この講評→改善→再挑戦の循環が、確かな成長を支えます。',
  'training.feedback.0.step': '01',
  'training.feedback.0.title': '実習観察',
  'training.feedback.0.titleEn': 'Observation',
  'training.feedback.0.description': '講師がロールプレイング中の所作・判断・言葉遣いを詳細に記録します。',
  'training.feedback.1.step': '02',
  'training.feedback.1.title': '個別講評',
  'training.feedback.1.titleEn': 'Review',
  'training.feedback.1.description': '実習直後に一人ひとりへ口頭でフィードバック。良かった点をまず伝え、その上で改善点を具体的に指導します。',
  'training.feedback.2.step': '03',
  'training.feedback.2.title': '改善実践',
  'training.feedback.2.titleEn': 'Improvement',
  'training.feedback.2.description': '指摘を受けた点を意識して、同じシナリオにもう一度挑戦。できなかったことができるようになる達成感を味わいます。',
  'training.feedback.3.step': '04',
  'training.feedback.3.title': '成長記録',
  'training.feedback.3.titleEn': 'Progress Record',
  'training.feedback.3.description': '各回の評価を蓄積し、受講生自身が成長の軌跡を振り返れるようにしています。',

  // FeedbackSystem additional
  'training.feedback.sectionTitleEn': 'Observe, Review, Improve',
  'training.feedback.imgAlt': '講師からフィードバックを受ける受講生',
  'training.feedback.imgCaption': '講師から個別フィードバックを受ける受講生',

  // SafetyEquipment
  'training.safety.label': 'AUTHENTIC EQUIPMENT',
  'training.safety.title': '安全・実物主義',
  'training.safety.titleEn': 'Safety & Authenticity',
  'training.safety.description': '当アカデミーの実技指導では、実物の什器・道具を使用します。模造品ではなく本物に触れることで、質感・重さ・扱い方を身体で覚えます。また、受講生の皆様には初日から白手袋を着用いただき、プロフェッショナルとしての所作の基礎を身につけます。',
  'training.safety.0.title': '実物の什器・道具',
  'training.safety.0.description': 'クリスタルガラス、シルバーカトラリー、高級陶磁器など、実際の邸宅で使用される本物の什器を用いて訓練します。',
  'training.safety.1.title': '白手袋の着用',
  'training.safety.1.description': '初日からプロ仕様の白手袋を着用。手の動き一つひとつに品格が宿るよう、基本の所作から徹底します。白手袋は、19世紀の英国で上流階級の邸宅のフットマンが白い綿の手袋をつけて給仕をした伝統に由来し、銀器や磁器に指紋を残さず美しく扱うという実用的な役割も担ってきました。実際の執事は時代や場面によって着用が異なり、必ず身につけるものではありませんでしたが、当アカデミーでは所作の精度と清潔さを身体で覚えていただくため、実習中は着用いただきます。',
  'training.safety.2.title': '安全への配慮',
  'training.safety.2.description': 'すべての実技は経験豊富な講師の監督のもとで行います。怪我や破損のリスクを最小限に抑え、安心して学べる環境を整えています。',

  // SafetyEquipment additional
  'training.safety.sectionTitleEn': 'Real Tools, Real Skills',
  'training.safety.imgAlt': '白手袋でカトラリーを整える受講生の手元',
  'training.safety.imgCaption': '白手袋でカトラリーを整える手元 —— 本物の什器を用いた実習',

  // FAQSection
  'training.faq.label': 'FAQ',
  'training.faq.title': 'よくあるご質問',
  'training.faq.titleEn': 'Frequently Asked Questions',
  'training.faq.footer': 'その他のご質問はフォームよりお寄せください',
  'training.faq.0.question': '実技はどのくらいありますか？',
  'training.faq.0.answer': '講義で学んだ内容を必ず実技で試す設計です。テーブルセッティングやサービスの実習、現場を想定したロールプレイングが学びの中心です。',
  'training.faq.1.question': 'どんな場面を想定しますか？',
  'training.faq.1.answer': '日常の家事サービスから、フォーマルな晩餐会の運営、緊急時の対応まで幅広いシナリオを用意しています。',
  'training.faq.2.question': '実技だけ体験できますか？',
  'training.faq.2.answer': 'はい。1日完結の体験講座で、所作やティーサービスを実際に体験いただけます。',

  // CTASection
  'training.cta.label': 'NEXT STEP',
  'training.cta.title': 'さらに学びを深める',
  'training.cta.body': '実技の裏付けとなる教材や、訓練で身につくスキルの全体像もぜひご確認ください。まずは体験講座で実際の空気を感じてみませんか。',
  'training.cta.note': '※ご相談はオンラインでも承ります',
  'training.cta.materials': '使用教材を見る',
  'training.cta.skills': '習得スキルを見る',
  'training.cta.seminar': '体験講座で実技を体験する',

  // RelatedPages
  'training.related.label': 'LEARN MORE',
  'training.related.title': '関連ページ',
  'training.related.titleEn': 'Explore Further',
  'training.related.viewLink': '詳しく見る',
  'training.related.0.title': '使用教材',
  'training.related.0.desc': '協会監修の教科書全15冊',
  'training.related.1.title': '習得スキル一覧',
  'training.related.1.desc': '身につく5つのスキル領域',
  'training.related.2.title': 'カリキュラム概要',
  'training.related.2.desc': '学びの全体像と進め方',
  'training.related.3.title': '体験講座',
  'training.related.3.desc': '1日で執事の所作を体験',

  // Last updated
  'training.lastUpdated': '最終更新: 2026年7月8日',
};

export default training;
